import type { Data } from "../../../dbbl/composites/request/request.types";

export type APIExceptionWarningCode = Brand<string, "APIExceptionWarningCode">;
export type APIExceptionErrorCode = Brand<string, "APIExceptionErrorCode">;

export const apiExceptionErrorCode = (code: string) =>
  code as APIExceptionErrorCode;

export type ErrorOrWarning<T> = {
  code: T;
  description?: string;
};

export type APIClientExceptionWarning = ErrorOrWarning<APIExceptionWarningCode>;
export type APIClientExceptionError = ErrorOrWarning<APIExceptionErrorCode>;

// Error payload from Django's form validation
export type FormError<Payload> = {
  id: string;
  message: {
    __all__?: string[];
  } & Partial<Record<keyof Payload, string[]>>;
};

// APIClientException represent errors returned from upstream integrations and
// so can contain additional complextity
export type APIClientException = {
  id: string;
  errors?: APIClientExceptionError[];
  warnings?: APIClientExceptionWarning[];
  message?: {
    message?: string;
  };
  reason?: string;
};

export type ApiError<Payload = Data> = {
  id: APIExceptionErrorCode;
  message: string;
} & Payload;
